module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/th/2-d221e332a1212d42ab425f3c9fc46d48.jpg";